import { gql } from '@at/sauron-platform-graphql'

export const userEmailVerificationQuery = gql`
    query UserEmailVerificationQuery {
        user {
            email
            emailVerified
        }
    }
`
